import { Button, Grid } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  if (["/", "/about", "/pricing"].includes(location.pathname)) {
    return (
      <Grid
        item
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ position: "absolute", bottom: 0, height: "100px", width: "100%" }}
      >
        {/* <Button size='small' variant="outline" component={Link} to="/about">About Me</Button> */}
        {/* <Button size="small" variant="outline" component={Link} to="/coaching">
          Pricing
        </Button> */}
        <Button
          size="small"
          variant="outline"
          component={Link}
          to="/privacy-policy"
        >
          Privacy Policy
        </Button>
      </Grid>
    );
  } else {
    return <></>;
  }
};

export default Footer;
